/**
 * Labstep
 *
 * @module components/Log/List
 * @desc List of logs
 */

import { LogListItem } from 'labstep-web/components/Log/ListItem';
import type { Log } from 'labstep-web/models/log.model';
import type React from 'react';
import styles from './styles.module.scss';
import type { LogListProps } from './types';

export const LogList: React.FC<LogListProps> = ({
  logs,
  entityName,
  selectedEntitySnapshot,
  setSelectedEntitySnapshot,
  showGroup,
}) => {
  return (
    <div className={styles.list} data-cy="components/Log/List">
      {logs.map((log: Log) => {
        return (
          <LogListItem
            key={log.id}
            log={log}
            entityName={entityName}
            selectedEntitySnapshot={selectedEntitySnapshot}
            setSelectedEntitySnapshot={setSelectedEntitySnapshot}
            showGroup={showGroup}
          />
        );
      })}
    </div>
  );
};
